import { Link } from "react-router-dom";
import { LogoDark } from "@/components/brand/Logo";

const columns = [
  {
    title: "Product",
    links: [
      { name: "Generate", path: "/generate" },
      { name: "How It Works", path: "/how-it-works" },
      { name: "Pricing", path: "/pricing" },
      { name: "API", path: "/developers" },
    ],
  },
  {
    title: "Community",
    links: [
      { name: "Community Home", path: "/community" },
      { name: "Community Insights", path: "/insights" },
      { name: "Story Sessions", path: "/community#stories" },
      { name: "She Leads", path: "/she-leads" },
      { name: "Blog", path: "/blog" },
    ],
  },
  {
    title: "Company",
    links: [
      { name: "About", path: "/about" },
      { name: "Careers", path: "/careers" },
      { name: "Contact", path: "/contact" },
      { name: "Book a Demo", path: "/contact#demo" },
      { name: "WhatsApp Support", path: "https://wa.me/919136262913?text=Hi%20RoleIQ%20Team%2C%20I%20would%20like%20to%20know%20more%20about%20your%20platform.", external: true },
    ],
  },
  {
    title: "Legal",
    links: [
      { name: "Privacy Policy", path: "/privacy" },
      { name: "Terms of Service", path: "/terms" },
      { name: "Security & Trust", path: "/trust" },
      { name: "Cookie Policy", path: "/cookies" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-navy text-white" data-testid="footer">
      <div className="max-w-6xl mx-auto px-4 pt-16 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-3" style={{ textDecoration: "none" }}>
              <LogoDark width={180} height={42} />
            </Link>
            <p className="font-dm text-white/30 text-[11px] mt-2 tracking-[0.3px]">
              &copy; {new Date().getFullYear()} RoleIQ. All rights reserved.
            </p>
            <p className="font-dm text-[11px] mt-1" style={{ color: "rgba(201,168,76,0.4)" }}>
              roleiq.pro
            </p>
            <p className="font-dm text-white/50 text-sm leading-relaxed mt-4">
              AI-Powered Intelligence for HR teams. Map every role. Grow every professional.
            </p>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-dm text-gold text-sm font-semibold mb-4">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.name}>
                    {link.external ? (
                      <a href={link.path} target="_blank" rel="noopener noreferrer" className="font-dm text-white/50 text-sm hover:text-gold transition-colors">{link.name}</a>
                    ) : (
                      <Link to={link.path} className="font-dm text-white/50 text-sm hover:text-gold transition-colors">{link.name}</Link>
                    )}
                  </li>
                ))}
                {col.title === "Legal" && (
                  <li><Link to="/admin" className="font-dm text-white/10 text-[10px] hover:text-white/30 transition-colors mt-4 inline-block">Admin</Link></li>
                )}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-dm text-white/30 text-xs">
            &copy; {new Date().getFullYear()} RoleIQ. All rights reserved.
          </p>
          <div className="flex gap-4">
            <Link to="/privacy" className="font-dm text-white/30 text-xs hover:text-gold transition-colors">Privacy</Link>
            <Link to="/terms" className="font-dm text-white/30 text-xs hover:text-gold transition-colors">Terms</Link>
            <Link to="/trust" className="font-dm text-white/30 text-xs hover:text-gold transition-colors">Trust</Link>
            <Link to="/cookies" className="font-dm text-white/30 text-xs hover:text-gold transition-colors">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
